import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PremiumModalService {
  private readonly visible = signal(false);
  private readonly message = signal('');

  readonly isVisible = this.visible.asReadonly();
  readonly currentMessage = computed(() => this.message());

  open(customMessage: string): void {
    this.message.set(customMessage);
    this.visible.set(true);
  }

  close(): void {
    this.visible.set(false);
    this.message.set('');
  }
}
